// SELECTOR FNS
import {hotelRatingSelector} from '@stencil/hotels-details-reducer/src/selectors';
import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
// ICONS
import RatingStarIcon from '../../../../../stories/Icons/RatingStarIcon';

const StarIcon = styled(RatingStarIcon)(
  props => `
  color: ${props.theme.colors.goYellow.dark};
`,
);

const StarWrapper = styled.span`
  padding: 0 2px;
`;

const Star = () => (
  <StarWrapper>
    <StarIcon />
  </StarWrapper>
);

function HotelRatingStars() {
  const hotelRating = useSelector(hotelRatingSelector);

  if (!hotelRating) {
    return null;
  }

  return (
    <span itemScope itemProp="starRating" itemType="http://schema.org/Rating">
      <meta itemProp="ratingValue" content={hotelRating} />
      {new Array(hotelRating).fill(1).map((_, i) => (
        // it is okay to do this because it's  static iteration
        /* eslint-disable react/no-array-index-key */
        <Star key={i} />
      ))}
    </span>
  );
}

export default HotelRatingStars;
